module.exports = __webpack_public_path__ + "static/media/phoneCropped_ro.12fb0f2c.png";